<template>
    <div style="width: 100%" id="divz" class="px-5">
        <v-overlay v-model="caricamento">
            <v-progress-circular
                indeterminate
                size="60"
                color="teal accent-2"
            ></v-progress-circular>
        </v-overlay>
        <v-row dense class="mt-3">
            <v-col cols="1">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-on="on"
                            v-bind="attrs"
                            class="mt-3"
                            @click="dialog_da_verificare = true"
                        >
                            <v-icon color="primary">mdi-table-check</v-icon>
                        </v-btn>
                    </template>
                    <span>Lista di task da verificare</span>
                </v-tooltip>
            </v-col>
            <v-col cols="2">
                <v-switch
                    dense
                    label="Nascondi completate"
                    v-model="mostra_completati"
                    @change="changeFilters"
                ></v-switch>
            </v-col>
            <v-col cols="3">
                <v-switch
                    dense
                    label="Nascondi da verificare"
                    v-model="mostra_verificare"
                    @change="changeFilters"
                ></v-switch>
            </v-col>
            <v-col cols="3">
                <v-text-field
                    dense
                    label="Cerca"
                    v-model="filtro_title"
                    clearable
                    @click:clear="filtro_title = null"
                    @change="changeFilters"
                >
                </v-text-field>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    dense
                    label="Progetti"
                    :items="progetti"
                    item-text="des_progetto"
                    item-value="id_progetto"
                    v-model="progetti_sel"
                    clearable
                    @click:clear="progetti_sel = []"
                    @change="changeFilters"
                    multiple
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="3">
                <v-autocomplete
                    dense
                    label="Profili"
                    :items="profili"
                    item-text="des_profilo_utente"
                    item-value="id_profilo_utente"
                    v-model="profili_sel"
                    clearable
                    @click:clear="profili_sel = []"
                    @change="changeFilters"
                    multiple
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    dense
                    label="Tipo progetto"
                    :items="tipiProg"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="filtro_tipo"
                    clearable
                    @click:clear="filtro_tipo = []"
                    @change="changeFilters"
                    multiple
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    dense
                    label="Stato"
                    :items="Object.keys(stati)"
                    v-model="filtroStato"
                    clearable
                    @click:clear="filtroStato = null"
                    @change="changeFilters"
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    dense
                    label="Creato da"
                    :items="utenti_creazione"
                    v-model="filtro_creazione"
                    clearable
                    multiple
                    @click:clear="filtro_creazione = null"
                    @change="changeFilters"
                >
                </v-autocomplete>
            </v-col>
        </v-row>

        <v-row id="rowz" style="min-height: 100vh" dense no-gutters>
            <v-col
                cols="2"
                class="pt-0"
                style="
                    overflow-x: scroll;
                    transform: rotateX(180deg);
                    height: 100%;
                "
                ><v-row
                    style="width: 100%; transform: rotateX(180deg)"
                    :key="aggiornarisorse"
                    dense
                    no-gutters
                >
                    <div
                        v-for="(item, index) in risorse.filter(
                            (e) => e.id_profilo_utente == -1
                        )"
                        :key="index"
                        style="width: 100%"
                    >
                        <div
                            v-if="index == 0"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                                border-radius: 5px 0px 0px 5px;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-2 ml-2 mt-8 pt-3"
                            >
                                {{
                                    item.nominativo + " (" + item.numTasks + ")"
                                }}
                            </h3>
                        </div>
                        <div
                            v-if="index == risorse.length - 1"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                                border-radius: 0px 5px 5px 0px;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-10 ml-5 mt-8 pt-3"
                            >
                                {{ item.nominativo }}
                            </h3>
                        </div>
                        <div
                            v-if="index != 0 && index != risorse.length - 1"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-10 ml-5 mt-8 pt-3"
                            >
                                {{ item.nominativo }}
                            </h3>
                        </div>
                        <draggable
                            v-model="item.tasks"
                            group="people"
                            @start="drag = true"
                            @end="(drag = false), assegnaTask()"
                            style="
                                height: 100%;
                                width: 100%;
                                max-height: 85vh;
                                overflow-y: scroll;
                            "
                        >
                            <div
                                v-for="(element, index) in item.tasks"
                                :key="index"
                                v-show="
                                    (progetti_sel.length == 0 ||
                                        progetti_sel.includes(
                                            element.id_progetto
                                        )) &&
                                    (filtro_title == null ||
                                        element.numero.includes(
                                            filtro_title
                                        )) &&
                                    (mostra_completati == false ||
                                        element.des_stato != 'Completato') &&
                                    (mostra_verificare == false ||
                                        element.des_stato != 'Da verificare') &&
                                    (filtroStato == null ||
                                        element.des_stato == filtroStato) &&
                                    (filtro_tipo.length == 0 ||
                                        filtro_tipo.includes(
                                            element.tipo_progetto
                                        )) &&
                                    (filtro_creazione.length == 0 ||
                                        filtro_creazione.includes(
                                            element.utente_creazione
                                        ))
                                "
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            v-on="on"
                                            v-bind="attrs"
                                            :class="element.class"
                                            @dblclick="
                                                OpenDialogComponente(element)
                                            "
                                            :style="
                                                'height: fit-content; width: 80%; border-radius: 10px; padding: 10px; margin-bottom: 10px; ' +
                                                'background-color: ' +
                                                stati[element.des_stato]?.color
                                            "
                                        >
                                            <span>
                                                <b>{{ element.numero }}</b>
                                            </span>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Tipo: " +
                                                    tipiProg.filter(
                                                        (e) =>
                                                            e.id_tabella ==
                                                            element.tipo_progetto
                                                    )[0]?.des
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Progetto: " +
                                                    progetti?.filter(
                                                        (e) =>
                                                            e.id_progetto ==
                                                            element.id_progetto
                                                    )[0]?.des_progetto
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Priorita: " +
                                                    element.priorita
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Creato da: " +
                                                    element.utente_creazione
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Cliente: " +
                                                    element.ragione_sociale
                                                }}
                                            </i>
                                            <template
                                                v-if="
                                                    element.senza_risposta !=
                                                    '0'
                                                "
                                            >
                                                <br />
                                                <i
                                                    style="
                                                        opacity: 0.7;
                                                        font-size: 14px;
                                                        font-weight: bold;
                                                    "
                                                    >Messaggi Bacheca Senza
                                                    Risposta!
                                                </i>
                                            </template>
                                            <br />
                                            <v-icon>{{
                                                stati[element.des_stato]?.icon
                                            }}</v-icon>
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 12px;
                                                "
                                                >{{ element.des_stato }}
                                            </i>
                                            <v-progress-linear
                                                striped
                                                :color="
                                                    calcolaColore(
                                                        element.percentuale_completamento
                                                    )
                                                "
                                                v-model="
                                                    element.percentuale_completamento
                                                "
                                                height="13"
                                            >
                                                <strong
                                                    >{{
                                                        Math.ceil(
                                                            element.percentuale_completamento
                                                        )
                                                    }}%</strong
                                                >
                                            </v-progress-linear>
                                        </div>
                                    </template>
                                    <span>{{
                                        element.titolo_task != null
                                            ? element.titolo_task
                                            : "Nessuna descrizione"
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </draggable>
                    </div>
                </v-row></v-col
            >
            <v-col
                cols="10"
                class="pt-0"
                style="
                    overflow-x: scroll;
                    transform: rotateX(180deg);
                    height: 100%;
                "
                ><v-row
                    style="width: max-content; transform: rotateX(180deg)"
                    :key="aggiornarisorse"
                    dense
                    no-gutters
                >
                    <div
                        v-for="(item, index) in risorse.filter(
                            (e) =>
                                (profili_sel.length == 0 ||
                                    profili_sel.includes(
                                        e.id_profilo_utente
                                    )) &&
                                e.id_profilo_utente != -1
                        )"
                        :key="index"
                    >
                        <div
                            v-if="index == 0"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                                border-radius: 5px 0px 0px 5px;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-10 ml-5 mt-8 pt-3"
                            >
                                {{
                                    item.nominativo + " (" + item.numTasks + ")"
                                }}
                            </h3>
                        </div>
                        <div
                            v-if="index == risorse.length - 1"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                                border-radius: 0px 5px 5px 0px;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-10 ml-5 mt-8 pt-3"
                            >
                                {{
                                    item.nominativo + " (" + item.numTasks + ")"
                                }}
                            </h3>
                        </div>
                        <div
                            v-if="index != 0 && index != risorse.length - 1"
                            class="mb-4"
                            style="
                                border-bottom: 1px solid grey;
                                height: 50px;
                                background-color: #3f51b5;
                            "
                        >
                            <h3
                                style="color: white"
                                class="mr-10 ml-5 mt-8 pt-3"
                            >
                                {{
                                    item.nominativo + " (" + item.numTasks + ")"
                                }}
                            </h3>
                        </div>
                        <draggable
                            v-model="item.tasks"
                            group="people"
                            @start="drag = true"
                            @end="(drag = false), assegnaTask()"
                            style="
                                height: 100%;
                                width: 250px;
                                max-height: 85vh;
                                overflow-y: scroll;
                            "
                        >
                            <div
                                v-for="(element, index) in item.tasks"
                                :key="index"
                                v-show="
                                    (progetti_sel.length == 0 ||
                                        progetti_sel.includes(
                                            element.id_progetto
                                        )) &&
                                    (filtro_title == null ||
                                        element.numero.includes(
                                            filtro_title
                                        )) &&
                                    (mostra_completati == false ||
                                        element.des_stato != 'Completato') &&
                                    (mostra_verificare == false ||
                                        element.des_stato != 'Da verificare') &&
                                    (filtroStato == null ||
                                        element.des_stato == filtroStato) &&
                                    (filtro_tipo.length == 0 ||
                                        filtro_tipo.includes(
                                            element.tipo_progetto
                                        )) &&
                                    (filtro_creazione.length == 0 ||
                                        filtro_creazione.includes(
                                            element.utente_creazione
                                        ))
                                "
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            v-on="on"
                                            v-bind="attrs"
                                            :class="element.class"
                                            @dblclick="
                                                OpenDialogComponente(element)
                                            "
                                            :style="
                                                'height: fit-content; width: 80%; border-radius: 10px; padding: 10px; margin-bottom: 10px; ' +
                                                'background-color: ' +
                                                stati[element.des_stato]?.color
                                            "
                                        >
                                            <span>
                                                <b>{{ element.numero }}</b>
                                            </span>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Tipo: " +
                                                    tipiProg.filter(
                                                        (e) =>
                                                            e.id_tabella ==
                                                            element.tipo_progetto
                                                    )[0]?.des
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Progetto: " +
                                                    progetti?.filter(
                                                        (e) =>
                                                            e.id_progetto ==
                                                            element.id_progetto
                                                    )[0]?.des_progetto
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Priorita: " +
                                                    element.priorita
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Creato da: " +
                                                    element.utente_creazione
                                                }}
                                            </i>
                                            <br />
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 14px;
                                                "
                                                >{{
                                                    "Cliente: " +
                                                    element.ragione_sociale
                                                }}
                                            </i>
                                            <template
                                                v-if="
                                                    element.senza_risposta !=
                                                    '0'
                                                "
                                            >
                                                <br />
                                                <i
                                                    style="
                                                        opacity: 0.7;
                                                        font-size: 14px;
                                                        font-weight: bold;
                                                    "
                                                    >Messaggi Bacheca Senza
                                                    Risposta!
                                                </i>
                                            </template>
                                            <br />
                                            <v-icon>{{
                                                stati[element.des_stato]?.icon
                                            }}</v-icon>
                                            <i
                                                style="
                                                    opacity: 0.7;
                                                    font-size: 12px;
                                                "
                                                >{{ element.des_stato }}
                                            </i>
                                            <v-progress-linear
                                                striped
                                                :color="
                                                    calcolaColore(
                                                        element.percentuale_completamento
                                                    )
                                                "
                                                v-model="
                                                    element.percentuale_completamento
                                                "
                                                height="13"
                                            >
                                                <strong
                                                    >{{
                                                        Math.ceil(
                                                            element.percentuale_completamento
                                                        )
                                                    }}%</strong
                                                >
                                            </v-progress-linear>
                                        </div>
                                    </template>
                                    <span>{{
                                        element.titolo_task != null
                                            ? element.titolo_task
                                            : "Nessuna descrizione"
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </draggable>
                    </div>
                </v-row></v-col
            >
        </v-row>
        <v-dialog persistent class="ma-0 pa-0" v-model="dialog_dettaglio_task">
            <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                <v-toolbar-title class="white--text">
                    Dettaglio Task
                </v-toolbar-title>
                <v-spacer />
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="closeDettaglio"
                            class="ml-auto"
                            v-bind="attrs"
                            v-on="on"
                            small
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>
            <v-card class="ma-0 pa-0" height="85vh" style="overflow: hidden">
                <div style="position: relative; height: 100%" class="ma-0 pa-0">
                    <WindowFrame
                        class="ma-n3 pa-0"
                        component="contabilita"
                        ref="windowframe"
                        :input_args="inputArgs"
                        :key="keyContabilita"
                    />
                </div>
            </v-card>
        </v-dialog>
        <v-dialog
            content-class="dialogX"
            v-model="dialog_componente"
            style="max-width: fit-content"
        >
            <v-card>
                <v-toolbar color="indigo">
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small
                        ><v-icon
                            color="error"
                            @click="dialog_componente = false"
                            >mdi-close</v-icon
                        ></v-btn
                    >
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <SingleTicket
                                ref="single"
                                :key="renderSingle"
                                :tipo_permesso="tipo_permesso"
                                :hide_back_arrow="true"
                                :assistenza="tipo_assistenza"
                                v-show="clicked == 'TCK'"
                            />
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            class="ma-0 pa-0"
            v-model="dialog_da_verificare"
            width="90vw"
            scrollable
        >
            <v-card>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Task da Verificare
                    </v-toolbar-title>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    show_filtri_dialog = !show_filtri_dialog
                                "
                                class="ml-auto"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="purple">
                                    {{
                                        show_filtri_dialog
                                            ? "mdi-filter-off"
                                            : "mdi-filter"
                                    }}
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Filtri</span>
                    </v-tooltip>
                    <v-spacer />
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_da_verificare = false"
                                class="ml-auto"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-row v-if="show_filtri_dialog" class="mt-2">
                        <v-col cols="3">
                            <v-text-field
                                dense
                                label="Cerca"
                                v-model="filtri_dialog.nome.filtro"
                                clearable
                                @click:clear="filtri_dialog.nome.filtro = null"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                dense
                                label="Creato da"
                                v-model="filtri_dialog.creato.filtro"
                                clearable
                                @click:clear="
                                    filtri_dialog.creato.filtro = null
                                "
                                :items="filtri_dialog.creato.lista"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                dense
                                label="Assegnato a"
                                v-model="filtri_dialog.assegnato.filtro"
                                clearable
                                @click:clear="
                                    filtri_dialog.assegnato.filtro = null
                                "
                                :items="filtri_dialog.assegnato.lista"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                dense
                                label="Progetto"
                                v-model="filtri_dialog.progetto.filtro"
                                clearable
                                @click:clear="
                                    filtri_dialog.progetto.filtro = null
                                "
                                :items="filtri_dialog.progetto.lista"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-data-table
                        :items="
                            taskDaVerificare.filter(
                                (e) =>
                                    (e.numero.includes(
                                        filtri_dialog.nome.filtro
                                    ) ||
                                        filtri_dialog.nome.filtro == null) &&
                                    (e.utente_creazione ==
                                        filtri_dialog.creato.filtro ||
                                        filtri_dialog.creato.filtro == null) &&
                                    (e.nominativo ==
                                        filtri_dialog.assegnato.filtro ||
                                        filtri_dialog.assegnato.filtro ==
                                            null) &&
                                    (e.des_progetto ==
                                        filtri_dialog.progetto.filtro ||
                                        filtri_dialog.progetto.filtro == null)
                            )
                        "
                        :headers="headersDaVerificare"
                    >
                        <template v-slot:[`item.dettaglio`]="{ item }">
                            <v-btn @click="OpenDialogComponente(item)" small>
                                <v-icon color="primary">mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:[`item.tipo`]="{ item }">
                            {{
                                tipiProg.filter(
                                    (e) => e.id_tabella == item.tipo_progetto
                                )[0]?.des
                            }}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <AddTask
            :id_task="id_task"
            :assistenza="tipo_assistenza"
            :id_parent="id_ticket"
            :key="renderTask"
            ref="tsk"
            v-show="clicked == 'TSK'"
        />

        <SingleTicket ref="single" v-show="false" />

        <v-snackbar
            content-class="snackbar"
            :color="snackbar_background"
            right
            v-model="snackbar"
            :timeout="3000"
        >
            <v-icon :color="snackbar_icon_color" :size="64">{{
                snackbar_icon
            }}</v-icon>
            <h2
                :style="{ color: snackbar_text_color + '!important' }"
                class="ml-16"
            >
                {{ snackbar_text }}
            </h2>

            <v-btn
                @click="snackbar = false"
                fab
                dark
                text
                small
                style="
                    margin-top: -6rem;
                    float: right !important;
                    margin-right: -1rem !important;
                "
            >
                <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import draggable from "vuedraggable";
import _ from "lodash";
import SingleTicket from "../TICKET/SingleTicket.vue";
import AddTask from "../TICKET/AddTask.vue";
export default {
    components: {
        WindowFrame,
        draggable,
        SingleTicket,
        AddTask,
    },
    data() {
        return {
            show_filtri_dialog: false,
            filtri_dialog: {
                nome: { lista: [], filtro: null },
                creato: { lista: [], filtro: null },
                assegnato: { lista: [], filtro: null },
                progetto: { lista: [], filtro: null },
                tipo: { lista: [], filtro: null },
            },
            dialog_da_verificare: false,
            taskDaVerificare: [],
            headersDaVerificare: [
                { text: "Dettaglio", value: "dettaglio" },
                { text: "Nome Task", value: "numero" },
                { text: "Creato da", value: "utente_creazione" },
                { text: "Data creazione", value: "data" },
                { text: "Assegnato a", value: "nominativo" },
                { text: "Cliente", value: "ragione_sociale" },
                { text: "Progetto", value: "des_progetto" },
                { text: "Tipo progetto", value: "tipo" },
            ],
            filtroStato: null,
            stati: {
                Aperto: { color: "#9999ff", icon: "mdi-new-box" },
                "In corso": { color: "#ffcc99", icon: "mdi-play-speed" },
                "Da verificare": { color: "#ff9999", icon: "mdi-pause-circle" },
                Completato: { color: "#99ff99", icon: "mdi-check-circle" },
            },
            utenti_creazione: [],
            filtro_creazione: [],
            tipiProg: [],
            profili: [],
            profili_sel: [],
            progetti: [],
            progetti_sel: [],
            keyContabilita: true,
            dialog_dettaglio_task: false,
            inputArgs: { show_toolbar: false, landing_page: "" },
            mostra_completati: true,
            mostra_verificare: true,
            mostra_reset_filtro: false,
            tasks: [],
            risorse: [],
            filtro_title: null,
            risorse_backup: [],
            tasks_backup: [],
            margine: "0 auto",
            altezza: "100%",
            larghezza: "70%",
            aggiornarisorse: true,
            snackbar: false,
            snackbar_background: "",
            snackbar_icon: "",
            snackbar_icon_color: "",
            snackbar_text: "",
            snackbar_text_color: "",
            dialog_componente: false,
            tipo_assistenza: 0,
            tipo_permesso: "",
            id_parent: 0,
            id_ticket: 0,
            id_task: 1,
            caricamento: false,
            scala: 1,
            renderSingle: 0,
            renderTask: false,
            clicked: null,
            filtro_tipo: [],
        };
    },
    mounted() {
        this.gettabella();
        this.getProgetti();
        this.getProfili();
        this.getRisorse();
        this.GetModuloMenu();
    },
    methods: {
        async getProgetti() {
            let request = null;
            request = {
                controller: "contabilita",
                method: "POST",
                richiesta: {
                    action: "getprogetti",
                    token: localStorage.user_token,
                    filtri: [],
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        this.progetti = res.data.result.progetti;
                    } else {
                        console.log("error: " + res.data.statusCode);
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        closeDettaglio() {
            this.dialog_dettaglio_task = false;
            this.getRisorse();
        },
        changeFilters() {
            for (var r of this.risorse) {
                r.numTasks = r.tasks.filter(
                    (e) =>
                        (this.progetti_sel.length == 0 ||
                            this.progetti_sel.includes(e.id_progetto)) &&
                        (this.filtro_title == null ||
                            e.numero.includes(this.filtro_title)) &&
                        (this.mostra_completati == false ||
                            e.des_stato != "Completato") &&
                        (this.mostra_verificare == false ||
                            e.des_stato != "Da verificare") &&
                        (this.filtroStato == null ||
                            e.des_stato == this.filtroStato) &&
                        (this.filtro_tipo.length == 0 ||
                            this.filtro_tipo.includes(e.tipo_progetto)) &&
                        (this.filtro_creazione.length == 0 ||
                            this.filtro_creazione.includes(e.utente_creazione))
                ).length;
            }
            this.risorse.sort((a, b) => b.numTasks - a.numTasks);
            this.aggiornarisorse = !this.aggiornarisorse;
        },
        async getProfili() {
            var request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getprofili",
                    token: localStorage.user_token,
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.profili = res.data;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore: Stato " + res.status
                        );
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                });
        },
        async gettabella() {
            const request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.user_token,
                    tipo: "TIPO_PROGETTO",
                    assistenza: 0,
                    filter: "validita = 1",
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    //this.caricamento_dati = false;
                    if (res.status === 200) {
                        console.log(res.data);
                        this.tipiProg = res.data;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((err) => {
                    //this.caricamento_dati = false;
                    console.error(err);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        async GetModuloMenu() {
            console.log("getmodulomenu");
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "getmenuparametri",
                    token: localStorage.getItem("user_token"),
                    cod_modulo: "quickproject",
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.inputArgs.landing_page +=
                        res.data.result.moduli[0].moduli_menu.filter(
                            (e) => e.path == "/progetti"
                        )[0].id_modulo_menu;
                    console.log(this.inputArgs);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        OpenDialogComponente(element) {
            console.log(element);
            this.inputArgs.landing_page = "/taskprogetti/" + element.id_progetto + "/" + element.id_ticket;
            this.dialog_dettaglio_task = true;
            this.keyContabilita = !this.keyContabilita;
        },
        calcolaColore(percentuale) {
            var colore = null;
            if (percentuale < 20) {
                colore = "red";
                return colore;
            } else if (percentuale >= 20 && percentuale < 70) {
                colore = "orange";
                return colore;
            } else if (percentuale >= 70 && percentuale < 100) {
                colore = "success";
                return colore;
            } else if (percentuale == 100) {
                colore = "green";
                return colore;
            }
        },
        getRisorse() {
            var getUtenti = {
                controller: "Utente",
                method: "POST",
                richiesta: {
                    action: "getutentelist",
                    token: localStorage.user_token,
                    id_utente: localStorage.id,
                },
            };
            this.$store.dispatch("api", getUtenti).then((res) => {
                if (res.status == 200) {
                    this.risorse = res.data.result.gp_personale_utenti.filter(
                        (e) =>
                            e.id_azienda == localStorage.id_azienda &&
                            e.validita == 1
                    );
                    this.risorse_backup = JSON.parse(
                        JSON.stringify(this.risorse)
                    );
                    this.risorse.forEach((e) => {
                        e.nominativo = e.nome + " " + e.cognome;
                        e.tasks = [];
                    });
                    console.log(this.risorse);
                    this.risorse.unshift({
                        id_utente: -1,
                        id_personale: -1,
                        id_profilo_utente: -1,
                        id_azienda: 40,
                        nome: "Non",
                        congnome: "Assegnato",
                        nominativo: "Non Assegnato",
                        validita: 1,
                        tasks: [],
                    });
                    this.risorse_backup.unshift({
                        id_utente: -1,
                        id_personale: -1,
                        id_profilo_utente: 10,
                        id_azienda: 40,
                        nome: "Non",
                        congnome: "Assegnato",
                        nominativo: "Non Assegnato",
                        validita: 1,
                        tasks: [],
                    });
                    this.getTasks();
                } else {
                    this.snackbar = true;
                    this.snackbar_background = "orange";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = "Nessun elemento trovato";
                    this.snackbar_text_color = "white";
                }
            });
        },
        getTasks() {
            this.caricamento = true;
            var request = {
                controller: "Ticket",
                method: "POST",
                richiesta: {
                    action: "gettasks",
                    token: localStorage.user_token,
                    id_stato: "",
                    id_ticket: null,
                    assistenza: 1,
                },
            };
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.tipo_permesso = res.data.result.tipo_permesso;
                        this.caricamento = false;
                        console.log("TICKETS:", res.data);
                        let tickets_tmp = res.data.result.lista;
                        this.taskDaVerificare = tickets_tmp.filter(
                            (e) => e.des_stato == "Da verificare"
                        );
                        for (const t of this.taskDaVerificare) {
                            if (
                                !this.filtri_dialog.assegnato.lista.includes(
                                    t.nominativo
                                )
                            ) {
                                this.filtri_dialog.assegnato.lista.push(
                                    t.nominativo
                                );
                            }
                            if (
                                !this.filtri_dialog.creato.lista.includes(
                                    t.utente_creazione
                                )
                            ) {
                                this.filtri_dialog.creato.lista.push(
                                    t.utente_creazione
                                );
                            }
                            if (
                                !this.filtri_dialog.progetto.lista.includes(
                                    t.des_progetto
                                )
                            ) {
                                this.filtri_dialog.progetto.lista.push(
                                    t.des_progetto
                                );
                            }
                        }
                        this.risorse.forEach((e) => {
                            if (e.tasks) {
                                e.tasks = [];
                            }
                        });
                        this.risorse_backup.forEach((e) => {
                            if (e.tasks_backup) {
                                e.tasks = [];
                            }
                        });
                        this.risorse.forEach((risorse) => {
                            tickets_tmp.forEach((ticket) => {
                                if (
                                    !this.utenti_creazione.includes(
                                        ticket.utente_creazione
                                    )
                                ) {
                                    this.utenti_creazione.push(
                                        ticket.utente_creazione
                                    );
                                }
                                if (
                                    risorse.id_personale ==
                                    ticket.id_responsabile
                                ) {
                                    if (ticket.numero != null) {
                                        if (ticket.numero.includes("TC")) {
                                            ticket.class =
                                                "draggableTicket mx-3 ml-5 mt-1";
                                        } else {
                                            ticket.class =
                                                "draggableTask mx-3 ml-5 m5-1";
                                        }
                                    } else {
                                        ticket.class =
                                            "draggableEmpty mx-3 ml-5 m5-1";
                                    }
                                    if (ticket.min_previsti != 0) {
                                        ticket.percentuale_completamento =
                                            (100 * ticket.min_lavorati) /
                                            ticket.min_previsti;
                                    } else {
                                        ticket.percentuale_completamento = 100;
                                    }
                                    risorse.tasks.push(
                                        Object.assign({}, ticket)
                                    );
                                }
                            });
                        });
                        this.risorse_backup = _.cloneDeep(this.risorse);

                        this.risorse.forEach((e) => {
                            e.numTasks = e.tasks.length;
                            e.tasks.sort((a, b) => a.priorita - b.priorita);
                        });
                        this.changeFilters();
                        console.log("RISORSE BACKUP:", this.risorse_backup);
                    } else {
                        this.snackbar = true;
                        this.snackbar_background = "orange";
                        this.snackbar_icon = "mdi-alert";
                        this.snackbar_icon_color = "white";
                        this.snackbar_text = "Nessun elemento trovato";
                        this.snackbar_text_color = "white";
                    }
                })
                .catch(() => {
                    this.caricamento = false;
                });
        },
        assegnaTask() {
            this.caricamento = true;
            for (let i = 0; i < this.risorse.length; i++) {
                for (let j = 0; j < this.risorse[i].tasks.length; j++) {
                    this.risorse[i].tasks[j].priorita = j;
                }
            }
            let tasks_tmp = [];
            this.risorse.forEach((e) => {
                if (e.tasks.length != 0) {
                    e.tasks.forEach((f) => {
                        f.id_responsabile = e.id_personale;
                        delete f.id_responsabile1;
                        f.id_risorsa = e.id_personale;
                        let obj_tmp = Object.assign({}, f);
                        tasks_tmp.push(obj_tmp);
                    });
                }
            });
            tasks_tmp.forEach((e) => {
                e.numero = e.numero.substring(4);
            });
            var request = {
                controller: "Ticket",
                method: "PUT",
                richiesta: {
                    action: "settasks",
                    id_utente: localStorage.id,
                    token: localStorage.user_token,
                    prefisso_utente: localStorage.prefisso_utente,
                    task: tasks_tmp,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                this.caricamento = false;
                if (res.status == 200) {
                    this.snackbar = true;
                    this.snackbar_background = "success";
                    this.snackbar_icon = "mdi-check-outline";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = "Ticket/Task assegnato con successo!";
                    this.snackbar_text_color = "white";
                    this.getTasks();
                } else {
                    this.snackbar = true;
                    this.snackbar_background = "orange";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text =
                        "Errore tecnico. Non è stato possibile salvare i dati!";
                    this.snackbar_text_color = "white";
                }
            });
            console.log("RISORSE AGGIORNATE:", this.risorse);
            console.log("TASK RIMASTI:", this.tasks);
            this.aggiornarisorse = !this.aggiornarisorse;
            //chiamata assegnaTask al BE
        },
    },
};
</script>
<style>
.draggableTicket:hover {
    cursor: grab;
    box-shadow: 0px 0px 10px cornflowerblue;
    transition: 0.25s;
}
.draggableTicket:active {
    cursor: grabbing;
    box-shadow: 0px 0px 12px aqua;
    transition: 0.25s;
}

.draggableEmpty {
    background-color: rgb(134, 132, 132);
    transition: 0.25s;
    box-shadow: 0px 0px 3px grey;
}

.draggableTicket {
    background-color: bisque;
    transition: 0.25s;
    box-shadow: 0px 0px 3px grey;
}

.draggableTask {
    background-color: lightgreen;
    transition: 0.25s;
    box-shadow: 0px 0px 3px grey;
}
.draggableTask:hover {
    cursor: grab;
    box-shadow: 0px 0px 10px rgb(60, 212, 67);
    transition: 0.25s;
}
.draggableTask:active {
    cursor: grabbing;
    box-shadow: 0px 0px 12px rgb(208, 255, 0);
    transition: 0.25s;
}
.glass {
    background: rgba(59, 59, 59, 0.7) !important;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37) !important;
    backdrop-filter: blur(5.5px) !important;
    -webkit-backdrop-filter: blur(5.5px) !important;
    border-radius: 10px !important;
    border: 1px solid rgba(255, 255, 255, 0.18) !important;
}
.icon {
    color: white;
    transition: 0.25s;
}
.icon:hover {
    color: #64ffda;
    transition: 0.25s;
}
.btn:hover {
    color: #64ffda !important;
    transition: 0.25s;
    transform: scale(1.1);
}
.dialogX {
    max-width: fit-content;
}
</style>
